import React, { useEffect, useState } from 'react';

import CommonImage from '@components/CommonImage';

import {
	useUpdateDestinationWiseQtyMutation,
	useUpdateFactoryPOMutation
} from '@features/order/api/OrderDetailsApi';

import { _getKey, printApiError, validateNumber } from '@utils/Util';

const ImportantNote = ({ factoryId, factoryPODetails }) => {
	const [factoryPoImportantNote, setFactoryPoImportantNote] = useState('');
	const [destinationWiseQtyList, setDestinationWiseQtyList] = useState([]);
	const [updateFactoryPO] = useUpdateFactoryPOMutation();
	const [updateDestinationWiseQty] = useUpdateDestinationWiseQtyMutation();

	useEffect(() => {
		if (factoryPODetails?.factoryPoImportantNote) {
			setFactoryPoImportantNote(factoryPODetails.factoryPoImportantNote);
		}
		if (factoryPODetails?.destinationWiseQuantityList?.length > 0) {
			setDestinationWiseQtyList(
				factoryPODetails.destinationWiseQuantityList.map((item) => ({
					...item,
					uId: _getKey()
				}))
			);
		} else {
			setDestinationWiseQtyList([
				{
					uId: _getKey(),
					destination: '',
					quantity: ''
				}
			]);
		}
	}, [factoryId, factoryPODetails]);

	const addDestination = () => {
		setDestinationWiseQtyList((prev) => [
			...prev,
			{
				uId: _getKey(),
				destination: '',
				quantity: ''
			}
		]);
	};

	const onChangeDestinationQty = (e, uId) => {
		const { name, value } = e.target;
		setDestinationWiseQtyList((prevList) =>
			prevList.map((item) => (item.uId === uId ? { ...item, [name]: value } : item))
		);
	};

	const onUpdateDestinationQty = (e, uId) => {
		try {
			const selected = destinationWiseQtyList.find((item) => item.uId === uId);
			if (selected?.destination && selected?.quantity) {
				updateDestinationWiseQty({
					id: factoryId,
					requestBody: selected
				});
			}
		} catch (e) {
			printApiError(e);
		}
	};

	const renderTableBody = () => {
		return destinationWiseQtyList?.map((item, idx) => {
			let length = destinationWiseQtyList.length;
			return (
				<tr key={`item_${item.uId}`}>
					{idx === 0 && (
						<td rowSpan={length} className="note-column">
							<div className="form-group h-100 mb-0">
								<textarea
									className="h-100"
									placeholder="write note"
									value={factoryPoImportantNote}
									onChange={(e) => setFactoryPoImportantNote(e.target.value)}
									onBlur={(e) => {
										updateFactoryPO({
											id: factoryId,
											requestBody: {
												factoryPoImportantNote: e.target.value
											}
										});
									}}
								/>
							</div>
						</td>
					)}
					<td className="destination-column">
						<div className="destination-and-add-btn">
							<div className="form-group mb-0">
								<textarea
									value={item.destination}
									name="destination"
									onChange={(e) => onChangeDestinationQty(e, item.uId)}
									onBlur={(e) => onUpdateDestinationQty(e, item.uId)}
								/>
							</div>
							{length - 1 === idx && (
								<div className="add-btn cursor-pointer" onClick={addDestination}>
									<CommonImage
										src="/icons/plus_dark_32.svg"
										alt=""
										width={32}
										height={32}
									/>
								</div>
							)}
						</div>
					</td>
					<td className="qty-column">
						<input
							type="text"
							placeholder="QTY"
							value={item.quantity}
							name="quantity"
							onChange={(e) => onChangeDestinationQty(e, item.uId)}
							onBlur={(e) => onUpdateDestinationQty(e, item.uId)}
							onKeyPress={validateNumber}
						/>
					</td>
				</tr>
			);
		});
	};

	return (
		<div className="note-and-destination-qty">
			<table className="table with-border no-hover">
				<thead>
					<tr>
						<th>Important Note</th>
						<th colSpan={2}>Destination wise QTY</th>
					</tr>
				</thead>
				<tbody>{renderTableBody()}</tbody>
			</table>
		</div>
	);
};

export default ImportantNote;
